import { createStore } from '@stencil/store';
import { SelectedSpaceOptionValueData } from '@artask/tambr-models/models/space-options.model';
import { OrderAddOn } from '@artask/tambr-models/models/add-on.model';


interface State {
  date: string;
  increments: number[];
  duration: number;
  spaceId: string;
  spaceOptions: SelectedSpaceOptionValueData[];
  addOns: OrderAddOn[];
  note: string;
}

const { state, onChange } = createStore<State>({
  date: null,
  increments: [],
  duration: null,
  spaceId: null,
  spaceOptions: [],
  addOns: [],
  note: null
});


function clearCalendarSelection() {
  state.spaceId = null;
  state.increments = [];
  state.duration = null;
  state.addOns = [];
  state.spaceOptions = [];
  state.note = null;
}


export { 
  state as selection, 
  onChange as onSelectionChange,
  clearCalendarSelection
};